<template>
  <v-row class="p-4">
    <div style="margin: 0 auto"></div>
  </v-row>
</template>

<script>
import { inject } from 'vue';
import { verify } from '@/services/clientSessionService';
import { storeToRefs } from 'pinia';
import { useUserStore } from '@/stores/user';

export default {
  name: 'Verify',
  setup() {
    const loginDialog = inject('loginDialog');
    return {
      loginDialog,
    };
  },
  data() {
    const userStore = useUserStore();
    const { user } = storeToRefs(userStore);

    return {
      userStore,
      user,
    };
  },
  async created() {
    const key = this.$route.params.verification_key;
    const email = this.$route.query.email;

    try {
      const registration = await verify(key, email);

      this.$root.$snackbar.message(`Email verified successfully`);
      if (this.user) {
        this.userStore.endSession();
      }
      let postLoginURL;
      if (registration.registration_metadata) {
        if (registration.registration_metadata.assistant_id) {
          postLoginURL = `/assistants/${
            registration.registration_metadata.assistant_id
          }?cid=${registration.registration_metadata.cids}&hours=${
            registration.registration_metadata.hours
          }&self_identifications=${
            registration.registration_metadata.self_identifications || ''
          }&availabilities=${
            registration.registration_metadata.availabilities || ''
          }&timezone=${registration.registration_metadata.timezone || ''}`;
        } else if (registration.registration_metadata.cids) {
          postLoginURL = `/search?cid=${registration.registration_metadata.cids}&hours=${registration.registration_metadata.hours}`;
        }
      }

      this.loginDialog.open({
        email,
        postLoginURL,
      });
    } catch (error) {
      this.$root.$snackbar.error(
        error?.data?.message ??
          `Unable to verify your email. Please try again later.`
      );
    }
    this.$router.push(`/`);
  },

  methods: {},
};
</script>
